import { Text } from '@radix-ui/themes';
import { RX } from 'enums/radix';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export const EB = (props: { errorMsg?: string; children: ReactNode }) => (
  <ErrorBoundary
    fallback={
      <Text color={RX.CLR.DANGER}>
        {props.errorMsg ?? 'Something went wrong'}
      </Text>
    }
  >
    {props.children}
  </ErrorBoundary>
);
